import React, { createContext, useContext, useEffect, useState } from 'react';
import Keycloak from 'keycloak-js';

const KeycloakContext = createContext(null);

const keycloak = new Keycloak({
  url:      process.env.REACT_APP_KEYCLOAK_URL,
  realm:    process.env.REACT_APP_KEYCLOAK_REALM,
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID
});

export const AuthProvider = ({ children }) => {
  const [initialized,   setInitialized]   = useState(false);
  const [authenticated, setAuthenticated] = useState(false);
  const [user, setUser]                   = useState(null);

  useEffect(() => {
    keycloak.init({
      onLoad:           'check-sso',
      checkLoginIframe: false,
      pkceMethod:       'S256'
    }).then((auth) => {
      setAuthenticated(auth);
      if (auth) {
        // ── Διαβάζει realm roles ΚΑΙ client roles (salon-frontend) ──
        const realmRoles  = keycloak.tokenParsed?.realm_access?.roles || [];
        const clientRoles = keycloak.tokenParsed?.resource_access?.['salon-frontend']?.roles || [];
        const roles = [...new Set([...realmRoles, ...clientRoles])];

        setUser({
          id:      keycloak.tokenParsed?.sub,
          name:    keycloak.tokenParsed?.name,
          email:   keycloak.tokenParsed?.email,
          salonId: keycloak.tokenParsed?.salon_id,
          roles,
          isAdmin: roles.includes('salon-admin'),
          isStaff: roles.includes('salon-staff') || roles.includes('salon-bookings') || roles.includes('salon-clients'),
        });
      }
      setInitialized(true);
    }).catch(() => {
      setInitialized(true);
    });

    keycloak.onTokenExpired = () => {
      keycloak.updateToken(60).catch(() => keycloak.login());
    };
  }, []);

  const login    = () => keycloak.login();
  const logout   = () => keycloak.logout({ redirectUri: window.location.origin });
  const getToken = () => keycloak.token;

  return (
    <KeycloakContext.Provider value={{
      initialized, authenticated, user,
      login, logout, getToken, keycloak
    }}>
      {children}
    </KeycloakContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(KeycloakContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};

export default keycloak;